import { EMAIL_HASH_QUERY_PARAM_NAME } from '../const';
import { TeamInvitationQueryParamsName } from '../types';

export const isTeamInvitationQuery = (query: string) => {
  const queryParams = new URLSearchParams(query);
  const queryNames = Object.values(TeamInvitationQueryParamsName);

  return queryNames.every(name => {
    // dual-accept (BE-1 email_hash rollout): the invitee address may arrive as
    // the legacy plaintext `email` param or only as the hashed `email_hash`,
    // so accept either one for that slot instead of demanding plaintext.
    if (name === TeamInvitationQueryParamsName.Email) {
      return (
        queryParams.has(name) || queryParams.has(EMAIL_HASH_QUERY_PARAM_NAME)
      );
    }

    return queryParams.has(name);
  });
};
